jQuery(document).ready(function ($) {
    function getSelectedIndex(api) {
        if (!api) return 0;

        if (typeof api.selectedSnap === 'function') {
            return api.selectedSnap();
        }

        if (typeof api.selectedScrollSnap === 'function') {
            return api.selectedScrollSnap();
        }

        return 0;
    }

    function getWrappedIndex(index, length) {
        if (!length) return 0;
        return ((index % length) + length) % length;
    }

    function getSlideNodes(api) {
        return api && typeof api.slideNodes === 'function' ? api.slideNodes() : [];
    }

    function getSlideIndexFromCard(api, $card) {
        var slideNodes = getSlideNodes(api);
        var slideEl = $card.closest('.flipcard-item')[0];

        return slideNodes.indexOf(slideEl);
    }

    function goToSlide(api, index) {
        if (!api) return;

        if (typeof api.goTo === 'function') {
            api.goTo(index, false, 'forward');
            return;
        }

        if (typeof api.scrollTo === 'function') {
            api.scrollTo(index, false);
        }
    }

    function stopAutoplay(api) {
        if (api && typeof api.plugins === 'function') {
            var plugins = api.plugins();
            var autoplay = plugins && plugins.autoplay;

            if (autoplay && typeof autoplay.stop === 'function') {
                autoplay.stop();
            }
        }
    }

    function setCardExpanded($card, expanded) {
        var wasExpanded = $card.hasClass('is-flipped');

        $card.toggleClass('is-flipped', expanded);
        $card.attr('aria-expanded', expanded ? 'true' : 'false');
        $card.find('.flip-card-front').attr('aria-hidden', expanded ? 'true' : 'false');
        $card.find('.flip-card-back').attr('aria-hidden', expanded ? 'false' : 'true');

        var flipcard = $.trim($card.attr('data-flipcard'));
        // if (!wasExpanded && expanded) {
        //     console.log(['trackEvent', 'Flipcard', 'Klick auf Flipcard', flipcard]);
        // }

        if (!wasExpanded && expanded && flipcard && window._mtm && typeof window._mtm.push === 'function') {
            window._paq.push(['trackEvent', 'Flipcard', 'Klick auf Flipcard', flipcard]);
        }
        if (!wasExpanded && expanded && flipcard && window._mtm && typeof window._mtm.push === 'function' && $('body').hasClass('page-id-50069')) {
            window._paq.push(['trackEvent', 'Landingpage Vorteile', 'Flipcard', flipcard]);
        }
    }

    function closeOtherCards($slider, $currentCard) {
        $slider.find('.wp-block-custom-blocks-flipcard-item').not($currentCard).each(function () {
            setCardExpanded($(this), false);
        });
    }

    function updateFocusableCards($slider, api) {
        var slideNodes = getSlideNodes(api);
        var activeSlide = slideNodes[getSelectedIndex(api)];

        $slider.find('.wp-block-custom-blocks-flipcard-item').attr('tabindex', '-1');

        if (activeSlide) {
            activeSlide.setAttribute('tabindex', '0');
        }
    }

    function focusCardElement($card) {
        if ($card && $card.length && $card[0]) {
            $card[0].focus({ preventScroll: true });
        }
    }

    function focusActiveCard($slider, api) {
        var slideNodes = getSlideNodes(api);
        var activeSlide = slideNodes[getSelectedIndex(api)];

        if (activeSlide) {
            activeSlide.focus({ preventScroll: true });
        }
    }

    function focusSlideByIndex($slider, api, index) {
        var slideNodes = getSlideNodes(api);
        var safeIndex = getWrappedIndex(index, slideNodes.length);
        var targetSlide = slideNodes[safeIndex];

        $slider.find('.wp-block-custom-blocks-flipcard-item').attr('tabindex', '-1');

        if (targetSlide) {
            targetSlide.setAttribute('tabindex', '0');
            targetSlide.focus({ preventScroll: true });
        }
    }

    function ensureA11y($slider, api) {
        $slider.attr({
            role: 'region',
            'aria-roledescription': 'carousel',
            'aria-label': 'Flipcards'
        });

        $slider.find('.wp-block-custom-blocks-flipcard-item').each(function (index) {
            var $card = $(this);
            var existingId = $card.attr('id');
            var cardId = existingId || ('flipcard-' + index + '-' + Math.random().toString(36).slice(2, 8));
            var backId = cardId + '-back';
            var isFlipped = $card.hasClass('is-flipped');

            $card.attr('id', cardId);
            $card.attr({
                role: 'button',
                'aria-expanded': isFlipped ? 'true' : 'false',
                'aria-controls': backId
            });

            $card.find('.flip-card-front').attr('aria-hidden', isFlipped ? 'true' : 'false');

            $card.find('.flip-card-back').first().attr({
                id: backId,
                'aria-hidden': isFlipped ? 'false' : 'true'
            });
        });

        updateFocusableCards($slider, api);
    }

    try {
        $('.wp-block-custom-blocks-flipcards').each(function () {
            var $slider = $(this);

            if ($slider.data('emblaApi')) {
                return;
            }

            var rootNode = this;
            var containerNode = rootNode.firstElementChild;

            if (!containerNode) {
                return;
            }

            var $container = $(containerNode);
            var $originalSlides = $container.children('.flipcard-item');

            if (!$originalSlides.length) {
                return;
            }

            var originalCount = $originalSlides.length;
            var safety = 0;

            function getTrackWidth() {
                var width = 0;

                $container.children('.flipcard-item').each(function () {
                    width += $(this).outerWidth(true);
                });

                return width;
            }

            while (getTrackWidth() < ($slider.outerWidth() * 3) && safety < 10) {
                $container
                    .children('.flipcard-item')
                    .slice(0, originalCount)
                    .clone(true, true)
                    .appendTo($container);

                safety++;
            }

            var plugins = [];

            // if (typeof EmblaCarouselAutoplay === 'function') {
            //     plugins.push(
            //         EmblaCarouselAutoplay({
            //             delay: 3000,
            //             stopOnMouseEnter: true,
            //             stopOnInteraction: false
            //         })
            //     );
            // }

            var emblaApi = EmblaCarousel(
                rootNode,
     {
        loop: true,
        align: 'center',
        dragFree: false,
        duration: 45,
        container: containerNode,
        slides: '.flipcard-item',
        breakpoints: {
            '(min-width: 1024px)': {
                dragFree: true
            }
        }
    },
                plugins
            );

            $slider.data('emblaApi', emblaApi);

            ensureA11y($slider, emblaApi);

            if (typeof emblaApi.on === 'function') {
                emblaApi.on('select', function () {
                    updateFocusableCards($slider, emblaApi);
                });

                emblaApi.on('settle', function () {
                    ensureA11y($slider, emblaApi);
                });

                emblaApi.on('reInit', function () {
                    ensureA11y($slider, emblaApi);
                });
            }
        });

        $(document).on('click', '.wp-block-custom-blocks-flipcard-item', function (e) {
            if ($(e.target).closest('a, button, input, select, textarea').length && e.target !== this) {
                return;
            }

            var $card = $(this);
            var $slider = $card.closest('.wp-block-custom-blocks-flipcards');
            var emblaApi = $slider.data('emblaApi');

            if (!emblaApi) {
                setCardExpanded($card, !$card.hasClass('is-flipped'));
                return;
            }

            stopAutoplay(emblaApi);

            var targetIndex = getSlideIndexFromCard(emblaApi, $card);

            if (targetIndex === -1) {
                setCardExpanded($card, !$card.hasClass('is-flipped'));
                return;
            }

            var currentIndex = getSelectedIndex(emblaApi);

            var oldHandler = $slider.data('emblaSettleHandler');
            if (oldHandler && typeof emblaApi.off === 'function') {
                emblaApi.off('settle', oldHandler);
                $slider.removeData('emblaSettleHandler');
            }

            closeOtherCards($slider, $card);

            if (currentIndex === targetIndex) {
                setCardExpanded($card, !$card.hasClass('is-flipped'));
                updateFocusableCards($slider, emblaApi);
                return;
            }

            setCardExpanded($card, true);

            var onSettle = function (api) {
                var slideNodes = getSlideNodes(api);
                var activeSlide = slideNodes[getSelectedIndex(api)];

                if (activeSlide) {
                    var $activeCard = $(activeSlide);
                    closeOtherCards($slider, $activeCard);
                    setCardExpanded($activeCard, true);
                    updateFocusableCards($slider, api);
                    focusCardElement($activeCard);
                }

                if (typeof api.off === 'function') {
                    api.off('settle', onSettle);
                }

                $slider.removeData('emblaSettleHandler');
            };

            $slider.data('emblaSettleHandler', onSettle);

            if (typeof emblaApi.on === 'function') {
                emblaApi.on('settle', onSettle);
            }

            goToSlide(emblaApi, targetIndex);
        });

        $(document).on('keydown', '.wp-block-custom-blocks-flipcard-item', function (e) {
            if ($(e.target).closest('a, button, input, select, textarea').length && e.target !== this) {
                return;
            }

            var $card = $(this);
            var $slider = $card.closest('.wp-block-custom-blocks-flipcards');
            var emblaApi = $slider.data('emblaApi');

            if (!emblaApi) {
                return;
            }

            var slideNodes = getSlideNodes(emblaApi);
            var currentIndex = slideNodes.indexOf(this);

            if (currentIndex === -1) {
                currentIndex = getSelectedIndex(emblaApi);
            }

            if (e.key === 'ArrowRight') {
                e.preventDefault();
                stopAutoplay(emblaApi);

                var nextIndex = getWrappedIndex(currentIndex + 1, slideNodes.length);
                focusSlideByIndex($slider, emblaApi, nextIndex);
                goToSlide(emblaApi, nextIndex);
                return;
            }

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                stopAutoplay(emblaApi);

                var prevIndex = getWrappedIndex(currentIndex - 1, slideNodes.length);
                focusSlideByIndex($slider, emblaApi, prevIndex);
                goToSlide(emblaApi, prevIndex);
                return;
            }

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                stopAutoplay(emblaApi);

                closeOtherCards($slider, $card);
                setCardExpanded($card, !$card.hasClass('is-flipped'));
                updateFocusableCards($slider, emblaApi);
                return;
            }
        });

        $(document).on('focusin', '.wp-block-custom-blocks-flipcards *', function () {
            var emblaApi = $(this).closest('.wp-block-custom-blocks-flipcards').data('emblaApi');
            stopAutoplay(emblaApi);
        });

    } catch (err) {
        console.error(err);
    }

    $('.flipcard-item').each(function () {
        var $card = $(this);
        var value = $.trim($card.find('.flipcard__front-heading > *').first().text());

        if (!value) return;

        $card.attr('data-flipcard', value);
    });

    $(document).on('click', '.flipcards__arrow', function (e) {
        e.preventDefault();

        var $slider = $(this).closest('.wp-block-custom-blocks-flipcards');
        var emblaApi = $slider.data('emblaApi');

        if (!emblaApi) {
            return;
        }

        stopAutoplay(emblaApi);

        if ($(this).hasClass('flipcards__arrow--prev')) {
            if (typeof emblaApi.scrollPrev === 'function') {
                emblaApi.scrollPrev();
            }
            return;
        }

        if (typeof emblaApi.scrollNext === 'function') {
            emblaApi.scrollNext();
        }
    });

});


// WEBPACK FOOTER //
// ./src/blocks/flipcards/js/script.js